













import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { ISeoFiltersItem } from '~/assets/interfaces/navigation'
import MixinGeneral from '~/assets/mixins/general'

@Component
export default class ComponentSeoFilters extends mixins(MixinGeneral) {
  @Prop({ type: Array, default: () => [] }) private items!: ISeoFiltersItem[]

  private mounted(): void {
    this.$emit('loaded')
  }
}
